/**
 * @typedef {{
 *          logic:Object,
 *          filters:Array.<{
 *                          field:string,
 *                          operator:string|function,
 *                          value?: any,
 *                          ignoreCase?:boolean
 *                        }>
 *       }} filter
 */

import React from "react";
import logo from "../Images/logo.png";
import rwdLoge from "../Images/RWD_logo.png";
import { useTranslation } from "react-i18next";
import { api } from "../Basic/ApiFetch";
import CacheLoader from "../Basic/CacheLoader";
import {
  HeaderFooterContext,
  LoginContext,
  SignInStatusContext,
  HeaderContext,
  SetHistory,
} from "../Basic/BasicData";
import { IsNullOrEmpty } from "../Basic/SDOExtension";
import {
  showGlobalConfirmBox,
  getGlobalServerConfig,
  globalState,
  resetGlobalServerConfig,
  showGlobalMessageBox,
} from "../Route/RootMiddleware";
import { Countdown } from "./CountDown";
import { Button, DropDownButton } from "@progress/kendo-react-buttons";
import { DropDownListWithValue } from "../Components/Dropdowns/DropDownListWithValue";
import "../Css/bootstrap.min.css";
import "../Css/ace.min.css";
import "../Css/Style.css";
import "../Css/all.css";
import { useHistory } from "react-router";
import AnnnounceWindow from "./AnnounceWindow";
import { MergePDFWindow } from "./MergePDF/MergePDFWindow";

const Head = (props) => {
  const { signInStatus, setSignInStatus } =
    React.useContext(SignInStatusContext);
  const { headerFooterStatus, setHeaderFooterStatus } =
    React.useContext(HeaderFooterContext);
  const { headerStatus, setHeaderStatus } =
    React.useContext(HeaderContext);
  const { loginStatus, setLoginStatus } =
    React.useContext(LoginContext);

  const [userAgentDDLList, setUserAgentDDLList] = React.useState({
    data: [], //下拉選單資料
    dataOri: [], //使用者資料 用於過濾並給下拉選單顯示
  });

  const [userAgent, setUserAgent] = React.useState(null);

  const { i18n, t } = useTranslation();
  const languageDDLList = [
    { text: "繁體中文", value: "zh-TW" },
    { text: "English", value: "en" },
  ];
  const RootHistory = useHistory();

  // 系統功能下拉選單出現與否
  const [sysFunDdlVisibility, setSysFunDdlVisibility] = React.useState(false)
  // 公告Window 開啟狀態
  const [isAnnWindowOpen, setIsAnnWindowOpen] = React.useState(false);
  const [isMergePDFOpen, setIsMergePDFOpen] = React.useState(false);
  /**
   * @function isSignOut
   * @description 呼叫showConfirmBox來確認是否登出
   */
  const isSignOut = () => {
    showGlobalConfirmBox("確定要登出系統嗎？", signOut);
  };

  React.useEffect(() => {
    //原本重設signInStatus的邏輯放在HomeRoutePanel裡面，但HomeRoute已將此Component註解，因此拉到Header裡面來做
    if (!signInStatus) {
      setSignInStatus();
    }
    SetHistory(props.history);

    //登入時給予body loginBodyBg的class來變更背景圖片
    document.body.className = "loginBodyBg";
    if (signInStatus && !headerFooterStatus) {
      getUserAgent();
      document.body.className = "";
    }
  }, [signInStatus]);

  /**
   * @function getUserAgent
   * @description 取得登入者還可以代理那些user
   */
  const getUserAgent = async () => {
    let url = getGlobalServerConfig().backEndUrl.get();
    let response = await api.Get(
      url + "EmpUser/ReadUserAgent",
      null,
      null,
      false
    );

    if (response && response.ok) {
      let data = await response.json();
      //若此為代理人則需將登入者的資料也加入(可以換回原來使用者)
      if (data[0].AGENT_ID != null) {
        let liveUser = await api.Get(url + `EmpUser/${data[0].AGENT_ID}`);
        if (liveUser && liveUser.ok) {
          let liveUserData = await liveUser.json();
          //將登入者+至代理人選單
          data.push(liveUserData);
        }
      }

      setUserAgentDDLList({
        ...userAgentDDLList,
        data: data,
        dataOri: data,
        //將ID與名稱組合
        dataWithCombinedField: data.map((item) => ({
          ...item,
          ID_NAME: `${item.USER_ID}-${item.USER_NAME}`,
        })),
      });

      setUserAgent(data[0]);
      getGlobalServerConfig().BasicData.userName.set(data[0].USER_NAME);
      getGlobalServerConfig().BasicData.userId.set(data[0].USER_ID);
      getGlobalServerConfig().BasicData.orgId.set(data[0].ORG_ID);
      getGlobalServerConfig().BasicData.orgName.set(data[0].ORG_NAME);
      getGlobalServerConfig().BasicData.email.set(data[0].USER_EMAIL);
      getGlobalServerConfig().BasicData.userType.set(data[0].UsrType);
      getGlobalServerConfig().BasicData.agentId.set(data[0].AGENT_ID);
    }
  };

  //變更代理人
  const changeUserAgent = async (e) => {
    let url = getGlobalServerConfig().backEndUrl.get();

    //找出代理人的資料
    let newAgentId = e.target.value;
    //如果變更的為原本的登入者則換回正常登入者的狀態
    url +=
      getGlobalServerConfig().BasicData.agentId.get() === newAgentId
        ? "Login/SetLiveUser"
        : "Login/SetAgent";

    let response = await api.Post(url, JSON.stringify(newAgentId));
    if (response.ok) {
      let result = await response.json();
      if (!result.success) {
        showGlobalMessageBox(result.message);
        return;
      }
    }

    let cacheLoader = CacheLoader();
    let loadResult = await cacheLoader.LoadCache();

    if (loadResult) {
      // 紀錄目前登入狀態
      setSignInStatus();
      RootHistory.push("/Home");
      window.location.reload();
    }
  };

  const onCloseMergePDFWindow = () => {
    setIsMergePDFOpen(false);
  }

  // 登出
  const signOut = async () => {
    // 清除BasicData
    resetGlobalServerConfig();
    // 清除快取
    await CacheLoader().DeleteCache();
    // 導頁導到登入頁面
    if (IsNullOrEmpty(RootHistory)) {
      window.location.href = process.env.PUBLIC_URL;
    } else {
      RootHistory.push("/");
    }
    // 紀錄目前登入狀態
    setSignInStatus();
  };

  const logoClick = () => {
    RootHistory
      ? RootHistory.location.pathname === "/SystemSelector"
        ? RootHistory.push("/SystemSelector")
        : RootHistory.push("/Home")
      : window.location.reload();
  };

  const clickHeaderButton = (item) => {
    switch (item) {
      case "0": //功能下拉選單
        setSysFunDdlVisibility(!sysFunDdlVisibility)
        break;
      case "1": //相關連結
        window.open("https://www.moea.gov.tw/Mns/dir/content/SubMenu.aspx?menu_id=42899", "_blank");
        break;
      case "2": //投資法規
        window.open("https://www.moea.gov.tw/Mns/dir/Investment/DirApply.aspx?kind=A&subkind=02&menu_id=42817", "_blank");
        break;
      case "3": //申請案件查詢
        break;
      case "4": //帳號資料維護
        RootHistory.push("/Home/EmpUserMdf");
        break;
      case "5": //操作說明
        break;
      case "6": //新增表單
        RootHistory.push("/Home/SelectPlan");
        break;
      case "7": //案件夾
        RootHistory.push("/Home/MyCaseFolder");
        break;
      case "8": //系統公告
        setIsAnnWindowOpen(true);
        break;
      case "9": //FAQ
        RootHistory.push("/FAQ");
        break;
      case "10": //登入
        RootHistory.push("/")
        setLoginStatus(0)
        break;
      case "11": //註冊
        RootHistory.push("/")
        setLoginStatus(1)
        break;
      case "12": //案件進度查詢
        RootHistory.push("/CaseProgress/Query")
        break;
      case "13":
        setIsMergePDFOpen(true);
        break;
    }
  }

  // 功能Header導到其他功能頁
  const SystemFunctionList = () => {
    return (
      <>
        <div onClick={() => { clickHeaderButton("6") }}><span>新增表單</span></div>
        <div onClick={() => { clickHeaderButton("7") }}><span>案件夾</span></div>
        <div onClick={() => { clickHeaderButton("8") }}><span>系統公告</span></div>
        <div onClick={() => { clickHeaderButton("13") }}><span>附件合併</span></div>
      </>
    );
  };

  // 有登入時載入props
  const logoButtonProp = CacheLoader().HasCache()
    ? {
      onClick: logoClick,
    }
    : {};

  return (
    <header
      style={
        headerFooterStatus
          ? { display: "none" }
          : signInStatus && !headerFooterStatus
            ? { backgroundColor: headerStatus ? "white" : "" }
            : {
              backgroundColor: "white",
              display: "flex",
              justifyContent: "space-between",
            }
      }
    >
      {signInStatus && !headerFooterStatus ? (
        <>
          <div className="bluebg_header_box container_90">
            <div className="bluebg_header_title">
              <div className="me-auto header_list_link" onClick={logoClick}><img src={logo} alt="" /></div>
              <div className="bluebg_header_right_list">
                <ul>
                  <li tabIndex={0} className="header_list_link"
                    onClick={() => { clickHeaderButton("0") }}
                    onBlur={() => setSysFunDdlVisibility(false)}
                  >
                    {t('moea_ic.header.features')}

                    {sysFunDdlVisibility &&
                      <div id="systemFunctionList" className="headerBtnList">
                        <SystemFunctionList />
                      </div>

                    }

                  </li>
                  <li className="header_list_link" onClick={() => { clickHeaderButton("12") }}>{t('moea_ic.header.caseProgress')}</li>
                  <li className="header_list_link" onClick={() => { clickHeaderButton("1") }}>{t('moea_ic.header.link')}</li>
                  <li className="header_list_link" onClick={() => { clickHeaderButton("2") }}>{t('moea_ic.header.regulation')}</li>
                  <li className="header_list_link" onClick={() => { clickHeaderButton("4") }}>{t('moea_ic.header.maintain')}</li>
                  {/* <li className="header_list_link">{t('moea_ic.header.guide')}</li> */}
                  <li className="header_list_link" onClick={() => { clickHeaderButton("9") }}>{t('moea_ic.header.faq')}</li>

                  <li>
                    <Countdown
                      ServerConfig={globalState.globalServerConfig}
                      signOut={signOut}
                    />
                  </li>
                  <hr className="s_line"></hr>
                  <li className="header_list_link" onClick={isSignOut}>
                    {t('moea_ic.header.logOut')}
                  </li>
                  {/* <li>
                    <DropDownButton
                      text={t('moea_ic.header.changeLanguage')}
                      textField="text"
                      items={languageDDLList}
                      onItemClick={(e) => {
                          i18n.changeLanguage(e.item.value);
                          localStorage.setItem('i18nextLng', e.item.value); // Save the selected language
                      }}
                    />
                  </li> */}
                </ul>
              </div>
            </div>
          </div>

          <div className="RWD_whitebg_header_box">
            <div className="RWD_whitebg_header_box_title">
              <div className="me-auto RWD_whitebg_header_box_logo_bg header_list_link" onClick={logoClick}><img src={rwdLoge} alt="" /></div>
              <div className="RWD_whitebg_header_box_right_list">
                <ul>
                  <li tabIndex={0} className="header_list_link"
                    onClick={() => { clickHeaderButton("0") }}
                    onBlur={() => setSysFunDdlVisibility(false)}
                  >
                    {t('moea_ic.header.features')}

                    {sysFunDdlVisibility &&
                      <div id="systemFunctionList" className="headerBtnList">
                        <SystemFunctionList />
                      </div>

                    }

                  </li>
                  <li className="header_list_link" onClick={() => { clickHeaderButton("12") }}>{t('moea_ic.header.caseProgress')}</li>
                  <li className="header_list_link" onClick={() => { clickHeaderButton("1") }}>{t('moea_ic.header.link')}</li>
                  <li className="header_list_link" onClick={() => { clickHeaderButton("2") }}>{t('moea_ic.header.regulation')}</li>
                  <li className="header_list_link" onClick={() => { clickHeaderButton("4") }}>{t('moea_ic.header.maintain')}</li>
                  {/* <li className="header_list_link">{t('moea_ic.header.guide')}</li> */}
                  <li className="header_list_link" onClick={() => { clickHeaderButton("9") }}>{t('moea_ic.header.faq')}</li>

                  <li>
                    <Countdown
                      ServerConfig={globalState.globalServerConfig}
                      signOut={signOut}
                    />
                  </li>
                  <hr className="s_line"></hr>
                  <li className="header_list_link" onClick={isSignOut}>
                    {t('moea_ic.header.logOut')}
                  </li>
                  {/* <li>
                    <DropDownButton
                      text={t('moea_ic.header.changeLanguage')}
                      textField="text"
                      items={languageDDLList}
                      onItemClick={(e) => {
                          i18n.changeLanguage(e.item.value);
                          localStorage.setItem('i18nextLng', e.item.value); // Save the selected language
                      }}
                    />
                  </li> */}
                </ul>
              </div>
            </div>
          </div>
          {/* <span {...logoButtonProp} className="headerLogo">
            <img
              title={t("common.title")}
              alt="Background"
              src={logo}
              style={{ margin: "8px 20px" }}
            />
            <h4>SDO 框架展示</h4>
          </span>
          <ul className="userInfo">
            <li>
              <Countdown
                ServerConfig={globalState.globalServerConfig}
                signOut={signOut}
              />
            </li>
            <li>
              {userAgent && (
                <div>
                  <DropDownListWithValue
                    name="AGENT_ID"
                    data={userAgentDDLList.dataWithCombinedField}
                    loading={!userAgentDDLList.dataWithCombinedField}
                    textField="ID_NAME"
                    dataItemKey="USER_ID"
                    value={userAgent.USER_ID}
                    onChange={changeUserAgent}
                  />
                </div>
              )}
            </li>
            <li>
              <Button type="button" onClick={isSignOut}>
                登出
              </Button>
            </li>
          </ul> */}
        </>
      ) : (
        //登入時的header
        <>
          <div className="login_top_box">
            <div className="login_top_box_title">
              <div className="me-auto logo_bg header_list_link" onClick={() => { clickHeaderButton("10") }}><img alt="" src={logo} /></div>
              <div className="login_top_box_right_list">
                <ul>
                  <li className="header_list_link" onClick={() => { clickHeaderButton("12") }}>{t('moea_ic.header.caseProgress')}</li>
                  <li className="header_list_link" onClick={() => { clickHeaderButton("1") }}>{t('moea_ic.header.link')}</li>
                  <li className="header_list_link" onClick={() => { clickHeaderButton("2") }}>{t('moea_ic.header.regulation')}</li>
                  <li className="header_list_link" onClick={() => { clickHeaderButton("9") }}>{t('moea_ic.header.faq')}</li>
                  {/* <li className="header_list_link">{t('moea_ic.header.guide')}</li> */}
                  <hr className="s_line"></hr>
                  <li className="header_list_link" onClick={() => { clickHeaderButton("11") }}>{t('moea_ic.header.register')}</li>
                  <li className="header_list_link" onClick={() => { clickHeaderButton("10") }}>{t('moea_ic.header.logIn')}</li>
                  {/* <li>
                    <DropDownButton
                      text={t('moea_ic.header.changeLanguage')}
                      textField="text"
                      items={languageDDLList}
                      onItemClick={(e) => {
                        i18n.changeLanguage(e.item.value);
                        localStorage.setItem('i18nextLng', e.item.value); // Save the selected language
                      }}
                    />
                  </li> */}
                </ul>
              </div>
            </div>
          </div>

          {/* 手機版 */}
          <div className="RWD_login_top_box">
            <div className="login_top_box_title">
              <div className="me-auto logo_bg header_list_link" onClick={() => { clickHeaderButton("10") }}><img alt="" src={logo} /></div>
              <div className="login_top_box_right_list">
                <ul>
                  <li className="header_list_link" onClick={() => { clickHeaderButton("12") }}>{t('moea_ic.header.caseProgress')}</li>
                  <li className="header_list_link" onClick={() => { clickHeaderButton("1") }}>{t('moea_ic.header.link')}</li>
                  <li className="header_list_link" onClick={() => { clickHeaderButton("2") }}>{t('moea_ic.header.regulation')}</li>
                  <li className="header_list_link" onClick={() => { clickHeaderButton("9") }}>{t('moea_ic.header.faq')}</li>
                  {/* <li className="header_list_link">{t('moea_ic.header.guide')}</li> */}
                </ul>
                <div className="flex_center">
                  <div className="header_list_link" onClick={() => { clickHeaderButton("11") }}>{t('moea_ic.header.register')}</div>
                  <hr className="s_line"></hr>
                  <div className="header_list_link" onClick={() => { clickHeaderButton("10") }}>{t('moea_ic.header.logIn')}</div>
                  {/* <div>
                    <DropDownButton
                      text={t('moea_ic.header.changeLanguage')}
                      textField="text"
                      items={languageDDLList}
                      onItemClick={(e) => {
                        i18n.changeLanguage(e.item.value);
                        localStorage.setItem('i18nextLng', e.item.value); // Save the selected language
                      }}
                    />
                  </div> */}
                </div>
              </div>
            </div>
          </div>


          {/* <div className="login_top_box">
            <div className="login_top_box_title">
              <div className="me-auto logo_bg"><img alt="" src={logo} /></div>
              <div className="login_top_box_right_list">
                <ul>
                  <li>相關連結</li>
                  <li>投資法規</li>
                  <li>操作說明</li>
                  <hr className="s_line"></hr>
                  <li>註冊</li>
                  <li>登入</li>
                </ul>
              </div>
            </div>
          </div> */}
        </>
      )}
      <AnnnounceWindow
        isOpen={isAnnWindowOpen}
        closeWindow={() => { setIsAnnWindowOpen(false) }}
      />
      {isMergePDFOpen &&
        <MergePDFWindow
          onCloseWindow={onCloseMergePDFWindow}
        />
      }
    </header>
  );
};
export default Head;
